import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import cropCycles from 'views/eywafarm/CropCycle/store/cropCycles'
import paymentHistory from 'views/eywafarm/Subscription/store/paymentHistory'
import { createAction } from '@reduxjs/toolkit'
const resetAllState = createAction ('resetAllState');

const rootReducer = (asyncReducers) => (state, action) => {
    //// **JSR,...TODO: Here some redirect Issue.
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        cropCycles,
        paymentHistory,
        ...asyncReducers,
    })
    if (action.type === 'auth/session/onSignOutSuccess') {
        return combinedReducer(state, action)
    }
    if (action.type === resetAllState.type) {
        state = undefined; // Reset the state to its initial values
    }
    return combinedReducer(state, action)
}
  
export default rootReducer
